import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { TreeviewComponent, TreeviewI18n, TreeviewItem } from '@soy-andrey-semyonov/ngx-treeview';
import { Observable, Subscription } from 'rxjs';
import { SimpleDataTreeviewI18n } from 'src/app/forms/simple-datatree/simple-datatree-i18n';
import { HTTPService } from 'src/app/services/http.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { ButtonList } from 'src/app/system-utils/actions-buttons/actions-buttons.component';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
import { ThemeService } from 'src/app/services/theme.service';

export class ItemCategory{
    name:string;
    active:boolean;
    id:string;
    slug:string;
    children:ItemCategory[];
}

@Component({
    selector: 'app-livelo-category',
    templateUrl: './livelo-category.component.html',
    styleUrls: ['./livelo-category.component.scss'],
    providers: [
        { provide: TreeviewI18n, useClass: SimpleDataTreeviewI18n }
    ],
    standalone: false
})
export class LiveloSearchCategoryComponent implements OnInit, OnDestroy {
  codecompany: any;
  sub:Subscription;
  lista:TreeviewItem[];
  buttonList:ButtonList[] = [];
  sub1:Subscription;
  
  @ViewChild(TreeviewComponent, { static: false }) treeviewComponent: TreeviewComponent;
  
  config = {
    hasAllCheckBox: false,
    hasFilter: true,
    hasCollapseExpand: true,
    decoupleChildFromParent: true,
  }
  clientid: any;
  acesstoken: any;

  constructor(private http:HTTPService, private uid:UserAuthenticationServices , private cd:ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data, public ThemeService:ThemeService,public dialogRef:MatDialogRef<any>, private spinner:NgxSpinnerService) { }


  onSelectedChange(evento){
  }

  onFilterChange(evento){

  }

  onClickLine(evento:TreeviewItem){
    
    if ( !evento.children ){
      this.dialogRef.close(evento.value);
    }
    
  }

  okFunction(){
    this.dialogRef.close();
  }

  ngOnInit(): void {

    
    this.codecompany = (this.data as UntypedFormGroup).get("CODECOMPANY").value;
    if ( this.codecompany == null ){
        this.dialogRef.close();
        throw  Error("Selecionar a empresa para buscar categorias.");
    }

    let ob = {
      "entityName":"Mktpactivecompanies",
      "sql":`SELECT A.APIKEY
            FROM MKTPACTIVECOMPANIES A INNER JOIN MKTPCOMPANIES B ON A.CODECOMPANY=B.CODECOMPANY
            WHERE A.CODECOMPANY=${this.codecompany}
            AND A.CODEMKTP=123
            AND A.STATUS=1
            AND A.ENVIRONMENT=1`
    }
     
    this.sub1 = this.http.post(ob,'JsonBrokerServices/findnative',false,true,true).subscribe(con=>{
         
        if( ObjectUtil.isNotEmpty(con['SQL'])){

          this.acesstoken  = con['SQL'][0]['APIKEY'];
          
          
          this.buttonList.push({
            color:"warn",
            description:"Sair",
            action: ()=>{
                this.okFunction();
            }
          })

          this.findCategories();
        }
      });
    
  }

  findCategories(){
    this.spinner.show();
    let ob = {
      "expressao": "getRequestData(GetCategoria,Auth,?,GET,null,{@HEADER},{@CODEMKTP})",
      "novo": true,
      "codecompany": this.codecompany,
      "codemktp": 123,
      "codecontract": 0,
      "values":[] 
    }

    let header = {
      key:'@HEADER',
      value:`Authorization:Bearer executeSQL(ACCESSTOKEN,MKTPTOKENSCOPE,SCOPE = 'mktp.livpontua.data.taxonomy.read' AND CODECOMPANY = {@CODECOMPANY} AND CODEMKTP = {@CODEMKTP})`
    }
    
    ob['values'].push(header);

    this.sub = this.http.post(ob,'FormulaServices/test', true,true,false).subscribe(data=>{
        this.transformData(data);
    },error=>{
        this.spinner.hide();
        throw error;
    },()=>{
        this.spinner.hide();
    })
  
  }

  transformData(data):void{
    this.lista = [new TreeviewItem({text:"Categorias",value:0, checked: false,collapsed:true, children: []})];

    if ( data != null && ObjectUtil.isNotEmpty(data['resultado'])){
        
      let resultado = JSON.parse(data['resultado']);
      let array:[] = resultado;
    
      for ( var item of array ){
      
        let category_id = item['id'];
        let display_category_name = item['name'];
        let children = item['children'];
        let dataItem:TreeviewItem = new TreeviewItem({text:display_category_name, value:category_id,collapsed:true, checked:false });
        
        if ( this.lista[0].children == null ){
          this.lista[0].children = [dataItem];
        }else{
          this.lista[0].children.push(dataItem);      
        }
        
        if ( children != null ){
          this.findItem(children,category_id,dataItem);
        }
      }
    }
    
  }

  
  findItem(array:Object[],  category_id:string, lista:TreeviewItem):void{

  
      let parentData = this.findParent(category_id,this.lista);

      for ( var item of array ){
          
          let category_id = item['id'];
          let display_category_name = item['name'];
          let children = item['children'];

          if ( parentData.children == null ){
            parentData.children = [ new TreeviewItem({text:category_id + ' - '+ display_category_name, value:category_id, collapsed:true, checked: false, children:[] })];
            }else{
            parentData.children.push( new TreeviewItem({text:category_id + ' - '+ display_category_name, value:category_id, collapsed:true, checked: false,  children:[] }))
          }
          
          if ( children != null ){
            this.findItem(children,category_id,parentData);
          }
          
      }  
  }
  

  findParent(id, currentNode:TreeviewItem[]):TreeviewItem{
      
    var i,
        currentChild:TreeviewItem,
        result:TreeviewItem;
        for (i = 0; i < currentNode.length; i++ ){
            currentChild = currentNode[i];
            if ( currentChild.value == id ){
              return currentChild;
            }else{
                if ( currentChild.children ){
                    result = this.findParent(id, currentChild.children);

                    if (result != null) {
                      return result;
                    }
                }
            }
        }

        return null;
  }

  ngOnDestroy(){
    if ( this.sub!= null ){ this.sub.unsubscribe()};
    if ( this.sub1!= null ){ this.sub1.unsubscribe()};

    
  }

}
